"use client";

import Link from "next/link";
import Image from "next/image";
import { motion } from "framer-motion";
import WindParticles from "./WindParticles";

export default function Hero() {
  return (
    <section className="hero-section flex justify-center items-center text-center relative overflow-hidden h-screen">
      <WindParticles />
      <div className="hero-content z-10">
        <motion.div
          initial={{ opacity: 0, y: -30, scale: 0.8 }}
          animate={{ opacity: 1, y: 0, scale: 1 }}
          transition={{ duration: 1.2, ease: "easeOut" }}
          className="mb-8"
        >
          <Image 
            src="/icon.svg" 
            alt="Becoming Wind Logo" 
            width={350} 
            height={350} 
            className="mx-auto"
            priority
          />
        </motion.div>

        <motion.h1 
          initial={{ opacity: 0, scale: 0.9 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 1.2, ease: "easeOut" }}
          className="text-5xl md:text-7xl mb-6"
        >
          Becoming Wind
        </motion.h1>
        
        <motion.p 
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1, delay: 0.4, ease: "easeOut" }}
          className="text-xl md:text-2xl mb-12 font-serif italic"
        >
          Melodic Folk-Metal aus NRW
        </motion.p>
        
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 1, delay: 0.8 }}
        >
          <Link 
            href="#termine" 
            className="btn-primary inline-block"
          >
            <motion.span
              animate={{ y: [0, -10, 0] }}
              transition={{ 
                duration: 2, 
                repeat: Infinity, 
                ease: "easeInOut" 
              }}
              className="inline-block"
            >
              Nächste Termine entdecken
            </motion.span>
          </Link>
        </motion.div>
      </div>
    </section>
  );
}